import React from 'react';

export default ({ name, avatar, url, linkClassName = '' }) => (
    <a href={url} className={`d-flex align-items-center ${linkClassName}`}>
        <img src={avatar} className="rounded-circle" style={{ width: 30, height: 30 }} />
        <span className="ml-2">{name}</span>
    </a>
);
